import { z } from 'zod';

import { momentFromDate, momentFromStr } from './datetimes/misc';
import { axleTimeFromStr } from './datetimes/time';

export const zodDateString = () => z.string().regex(/^\d{4}-\d{2}-\d{2}$/);
export const zodDate = () => zodDateString().transform(momentFromStr);
export const zodDatetime = () => z.coerce.date().transform(momentFromDate);
export const zodTime = () => z.coerce.string().time().transform(axleTimeFromStr);
